type DateRangeExtractor = {
  name: string;
  isDateRangeFetchable?: boolean;
  dateRangeMethod?: 'checkIn/checkOut' | 'bookedAt' | 'creationDate';
};

export const shouldShowExtractDateRangeInput = ({
  extractors,
  extractType,
  extractAllKey,
}: {
  extractors: DateRangeExtractor[];
  extractType: string | null | undefined;
  extractAllKey: string;
}): boolean => {
  if (!extractType || extractType === extractAllKey) return false;

  return extractors.some(
    (extractor) =>
      extractor.name === extractType && extractor.isDateRangeFetchable === true
  );
};

export const getExtractDateRangeMethod = ({
  extractors,
  extractType,
  extractAllKey,
}: {
  extractors: DateRangeExtractor[];
  extractType: string | null | undefined;
  extractAllKey: string;
}): DateRangeExtractor['dateRangeMethod'] | undefined => {
  if (!extractType || extractType === extractAllKey) return undefined;

  const extractor = extractors.find((item) => item.name === extractType);

  if (!extractor || extractor.isDateRangeFetchable !== true) return undefined;

  return extractor.dateRangeMethod;
};
